import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import AOS from 'aos/dist/aos';
import { withStyles } from '@material-ui/core';
import NavBar from './components/navigation/NavBar';
import 'aos/dist/aos.css';
import Routing from './Routing';

AOS.init({ once: true });

const styles = (theme) => ({
  wrapper: {
    backgroundColor: theme.palette.common.white,
    //need no overflow and height set here to allow the NavBar sticky property to work!!!
    //overflowX: "hidden",
    height: '100%',
  },
});

function Main(props) {
  const { classes } = props;
  const [selectedTab, setSelectedTab] = useState(null);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  const setTab = useCallback(
    (tabName) => {
      switch (tabName) {
        case 'Home':
          document.title = 'Nexspec';
          break;
        case 'Solutions':
          document.title = 'Solutions';
          break;
        case 'Services':
          document.title = 'Services';
          break;
        case 'Company':
          document.title = 'Company';
          break;
        case 'Contact':
          document.title = 'Contact';
          break;
        case 'Privacy':
          document.title = 'Privacy';
          break;
        default:
          document.title = 'Nexspec';
      }
      setSelectedTab(tabName);
    },
    [setSelectedTab]
  );

  const handleMobileDrawerOpen = useCallback(() => {
    setIsMobileDrawerOpen(true);
  }, [setIsMobileDrawerOpen]);

  const handleMobileDrawerClose = useCallback(() => {
    setIsMobileDrawerOpen(false);
  }, [setIsMobileDrawerOpen]);

  return (
    <div className={classes.wrapper}>
      <NavBar
        selectedTab={selectedTab}
        selectTab={setSelectedTab}
        mobileDrawerOpen={isMobileDrawerOpen}
        handleMobileDrawerOpen={handleMobileDrawerOpen}
        handleMobileDrawerClose={handleMobileDrawerClose}
      />
      <Routing setTab={setTab} />
    </div>
  );
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(memo(Main));
